module.exports = __webpack_public_path__ + "img/recette-edit-3pcegramme.0830bf14.png";